module.exports = {
  "version": "0.30.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 296
// module chunks = 1